export const enum Culture {
  NL = "nl-NL",
  EN = "en-US",
}
